import apiClient from '@/services/axios'

export async function get(venueId, role) {
  var response = await apiClient.get(`/PersonalTodos/${venueId}/${role}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get todos')
}
